module.exports = __webpack_public_path__ + "assets/Heebo-Bold.1858bff968d8f5c16c646d9b18fd2259.woff";